import React from 'react'
import PropTypes from 'prop-types'
import {Redirect} from 'react-router-dom'
import {useSelector} from 'react-redux'

import {makeStyles} from '@material-ui/core/styles'
import {Typography, Grid, Hidden, Container} from '@material-ui/core'

import Page from 'components/Page/Page'

import Ledger from './Ledger.js'

const useStyles = makeStyles((theme) => ({}))

const LedgerPage = ({children}) => {
  const auth = useSelector(state => state.auth)
  const classes = useStyles()

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  if (!auth.access_token) {
    return <Redirect to="/login"/>
  }

  function hasPermission(perm) {
    for (var i = 0; i < auth.permissions.length; i++) {
      if (auth.permissions[i][0] == perm[0] && auth.permissions[i][1] == perm[1]) {
        return true
      }
    }
    return false
  }

  return (
    <Page title="Ledger">
      <Container maxWidth={false}>

        <Typography color="primary" variant="h1">
          Your ledger
        </Typography><br/>

        {(hasPermission(["Admin", "admin"]) || hasPermission(["Normal", "user"])) &&
          <Ledger/>
        }
      </Container>
    </Page>
  )
}

export default LedgerPage

LedgerPage.propTypes = {
  children: PropTypes.node
}
